import*as React from"react";const NavigationHelpersContext=React.createContext(void 0);export default NavigationHelpersContext;